module.exports = __webpack_public_path__ + "img/userid-tip.1ba4b92.jpg";